import React from 'react'
import { IconButton, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import Loading from '../../../Component/Loading'
import useMuiCompontent from '../../../Hooks/useMuiCompontent'
import { NoRecordFound } from '../../../Component/NoRecordFound'
import { Peginationcomponent } from '../../../Component/Peginationcomponent'
import { IoMdAdd } from 'react-icons/io'
import { IoIosSearch } from "react-icons/io";
import { FiRefreshCcw } from 'react-icons/fi'
import useTableSorting from '../../../Hooks/useTableSorting'
import useMedicine from '../Hooks/useMedicine'
import { Modal } from 'react-bootstrap'
import { SelectBox } from '../../../Component/Inputs'
import { activeStatusOption, dailogAllMessage } from '../../../Context/constants'
import { BiArchiveIn } from 'react-icons/bi'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddMedicine from './compoent/addMedicine'
import AddInventory from './compoent/addInventory'
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { LuImport } from "react-icons/lu";
import { AiOutlineCloudUpload } from "react-icons/ai";
import useDragDrop from '../../../Hooks/useDrag&Drop'
import moment from 'moment-timezone'
import { useNavigate } from 'react-router-dom'
import { Errors } from '../../../Component/Error'
const Medicine = () => {
    const { data, methods } = useMedicine()

    const {
        headCells,
        controller,
        inventoryController,
        vendorController,
        Filter,
        inventoryFilter,
        vendorFilter,
        TotalCount,
        medicineList,
        loader,
        openModal,
        excelref,
        importFile,
        tab,
        headInventoryCells,
        headVendorCells,
        inventoryList,
        vendorList,
        userdata,
    } = data

    const {
        handleChangeFilter,
        HandleSearchList,
        handleOpenModal,
        handleClosedModal,
        setController,
        setInventoryController,
        setVendorController,
        reset,
        archiveUnarchive,
        archiveVendor,
        archiveInventory,
        handleExportMedicine,
        handleDownloadInventory,
        handleVendorInventory,
        handleImportMedicine,
        uploadExcel,
        ChangeTab,
        handleAddAndReleaseStock,
        setOpenModal,
        getFullVendorList,
    } = methods
    const { CustomButton } = useMuiCompontent()
    const { EnhancedTableHead, order, orderBy, stableSort, getComparator, handleRequestSort } = useTableSorting(headCells)
    const { handleDragEnter, handleDragLeave, handleDragOver, handleDrop } = useDragDrop()
    const {
        EnhancedTableHead: EnhancedTableInventory,
        order: orderInventory,
        orderBy: orderByInventory,
        stableSort: stableSortInventory,
        getComparator: getComparatorInventory,
        handleRequestSort: handleRequestSortInventory,
    } = useTableSorting(headInventoryCells)

    const {
        EnhancedTableHead: EnhancedTableVendor,
        order: orderVendor,
        orderBy: orderByVendor,
        stableSort: stableSortVendor,
        getComparator: getComparatorVendor,
        handleRequestSort: handleRequestSortVendor,
    } = useTableSorting(headVendorCells)

    const navigate = useNavigate();

    return (
        <>
            {/* <ToastContainer /> */}
            {loader && <Loading />}
            <div className=''>
                <div className='row px-1'>
                    <div className="col-12 px-0 mt-3 d-flex justify-content-between pb-3" style={{ borderBottom: "2px solid #ededed" }}>
                        <ul className="nav  mb-0  ">
                            <li className="nav-item" role="presentation">
                                <button className={`teams_frofile_stepper_btn ms-2 me-2 ${tab === 1 && "active_teams_frofile"}`} id="personal" type="button" onClick={() => ChangeTab("generalMedicine")} >General Medicine</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`teams_frofile_stepper_btn ${tab === 2 && "active_teams_frofile"}`} id="education" type="button" onClick={() => ChangeTab("inventory")} >Inventory Management</button>
                            </li>
                            <li className="nav-item" role="presentation">
                                <button className={`teams_frofile_stepper_btn ${tab === 3 && "active_teams_frofile"}`} id="education" type="button" onClick={() => ChangeTab("vendorManagement")} >Vendor Management</button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            {
                tab === 1 &&

                <div className=" py-2" style={{ height: "100%" }}>
                    <div className='pb-2 d-flex justify-content-between ' style={{ borderBottom: "2px solid #ededed" }}>
                        <ul className="headerlist px-0">
                            <li className='me-2' style={{ width: "210px" }}> <input type="text" placeholder="Search" className="form-control filter_input" name='search' value={Filter?.search} onChange={handleChangeFilter} /> </li>

                            <li className="me-2" style={{ width: 150 }}>
                                <SelectBox
                                    placeholder="Select"
                                    value={Filter?.archive}
                                    name="archive"
                                    keys="value"
                                    label="label"
                                    menuValeu="value"
                                    handleChange={handleChangeFilter}
                                    option={activeStatusOption}
                                />
                            </li> <li className='me-2'><CustomButton disabled={Filter?.disable_button} startIcon={<IoIosSearch />} variant="contained" onClick={HandleSearchList}>search</CustomButton></li>
                            <li className="me-2" >
                                <IconButton onClick={reset} size="small" aria-label="delete" disabled={Filter?.disable_button} style={{ color: "#000", cursor: "pointer" }}>
                                    <FiRefreshCcw />
                                </IconButton>
                            </li>
                            <li><CustomButton startIcon={<IoMdAdd />} variant="contained" onClick={() => handleOpenModal("addMedicine")}>add new Medicine</CustomButton></li>
                        </ul>
                        <ul className="headerlist px-0 ">
                            <li>
                                <CustomButton variant="contained"
                                    onClick={handleExportMedicine}
                                    style={{ background: "#f5f5f5", color: "black" }}
                                    startIcon={<ExitToAppIcon />}
                                >export</CustomButton>
                            </li>
                            <li className='ms-2'>
                                <CustomButton variant="contained"
                                    onClick={() => handleOpenModal("importMedicine")}
                                    style={{ background: "#f5f5f5", color: "black" }}
                                    startIcon={<LuImport />}
                                >import</CustomButton>
                            </li>
                        </ul>
                    </div>
                    <div className="row" >
                        <div className="col-12 h-100 pt-3">

                            <TableContainer   >
                                {medicineList.length === 0 && <div className="col-sm-12 mt-3 text-center " > <NoRecordFound /> </div>}
                                <Table
                                    id="table_mui"
                                    aria-labelledby="tableTitle"
                                    size={"medium"}
                                    aria-label="enhanced table" >
                                    {
                                        medicineList?.length !== 0 && <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} rowCount={medicineList?.length} />
                                    }
                                    <TableBody className="table_overflow_scroll" >
                                        {stableSort(medicineList, getComparator(order, orderBy)).map(
                                            (row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return <React.Fragment key={index}><TableRow id="hover_tr" style={{ cursor: 'pointer' }}>
                                                    <TableCell className="ps-3" component="th" id={labelId} scope="row" padding="none" >
                                                        {controller?.rowsPerPage * (controller?.page - 1) + index + 1}
                                                    </TableCell>
                                                    <TableCell id={labelId} align="left" >{row?.name || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" >{row?.abbr || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" >{row?.brandName || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" >{row?.medicineType || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" >{`${row?.dose || ""} ${row?.unit || ""}`}</TableCell>
                                                    <TableCell id={labelId} align="left" style={{ textWrap: "wrap" }}>{row?.reaction || ""}</TableCell>
                                                    <TableCell id={labelId} align="right" ><MoreVertIcon type="button" data-bs-toggle="dropdown" aria-expanded="false" />
                                                        <ul className="dropdown-menu dropdown-menu-end me-3">
                                                            <li><button className="dropdown-item" onClick={() => handleOpenModal("addMedicine", row)}><i className="fa-solid fa-pen-to-square all_icons_color me-2 fs-6"></i>Edit Medicine</button></li>
                                                            <li><button className="dropdown-item" onClick={() => handleOpenModal("addMedicine", { ...row, clone: true })}><i className="fa-regular fa-clone cursor all_icons_color fs-6  me-2" />Clone Medicine</button></li>
                                                            <li><button className="dropdown-item" onClick={() => handleOpenModal("archive", row)}><BiArchiveIn className="all_react_icons_color me-2" />{`${row?.activeStatus === true ? "Archive" : "Unarchive"} Medicine`}</button></li>
                                                        </ul></TableCell>
                                                </TableRow>
                                                </React.Fragment>
                                            }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <nav className=" w-100  " aria-label="pagination">
                            {TotalCount > 10 && <Peginationcomponent count={TotalCount} controller={controller} setController={setController} />}
                        </nav>
                    </div>
                </div>
            }
            {
                tab === 2 &&
                <div className=" py-2" style={{ height: "100%" }}>
                    <div className='pb-2 d-flex justify-content-between ' style={{ borderBottom: "2px solid #ededed" }}>
                        <ul className="headerlist px-0">
                            <li className='me-2' style={{ width: "210px" }}> <input type="text" placeholder="Search" className="form-control filter_input" name='inventorySearch' value={inventoryFilter?.inventorySearch} onChange={handleChangeFilter} /> </li>

                            <li className="me-2" style={{ width: 150 }}>
                                <SelectBox
                                    placeholder="Select"
                                    value={inventoryFilter?.inventoryArchive}
                                    name="inventoryArchive"
                                    keys="value"
                                    label="label"
                                    menuValeu="value"
                                    handleChange={handleChangeFilter}
                                    option={activeStatusOption}
                                />
                            </li>
                            <li className='me-2'><CustomButton disabled={inventoryFilter?.inventory_disable_button} startIcon={<IoIosSearch />} variant="contained" onClick={HandleSearchList}>search</CustomButton></li>
                            <li className="me-2" >
                                <IconButton onClick={reset} size="small" aria-label="delete" disabled={inventoryFilter?.inventory_disable_button} style={{ color: "#000", cursor: "pointer" }}>
                                    <FiRefreshCcw />
                                </IconButton>
                            </li>
                            <li><CustomButton startIcon={<IoMdAdd />} variant="contained" onClick={() => { const url = `/setting/inventory/add`; navigate(url); }}>add Inventory</CustomButton></li>
                        </ul>
                        <ul className="headerlist px-0 ">
                            <li>
                                <CustomButton variant="contained"
                                    onClick={handleDownloadInventory}
                                >Download</CustomButton>
                            </li>
                        </ul>
                    </div>
                    <div className="row" >
                        <div className="col-12 h-100 pt-3">

                            <TableContainer   >
                                {inventoryList.length === 0 && <div className="col-sm-12 mt-3 text-center " > <NoRecordFound /> </div>}
                                <Table
                                    id="table_mui"
                                    aria-labelledby="tableTitle"
                                    size={"medium"}
                                    aria-label="enhanced table" >
                                    {
                                        inventoryList?.length !== 0 && <EnhancedTableInventory order={orderInventory} orderBy={orderByInventory} onRequestSort={handleRequestSortInventory} rowCount={inventoryList?.length} />
                                    }
                                    <TableBody className="table_overflow_scroll" >
                                        {stableSortInventory(inventoryList, getComparatorInventory(orderInventory, orderByInventory)).map(
                                            (row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return <React.Fragment key={index}><TableRow id="hover_tr" style={{ cursor: 'pointer' }}>
                                                    <TableCell className="ps-3" component="th" id={labelId} scope="row" padding="none" >
                                                        {inventoryController?.rowsPerPage * (inventoryController?.page - 1) + index + 1}
                                                    </TableCell>
                                                    <TableCell id={labelId} align="left" >{row?.batchNumber || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" > {row?.productName || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" > {row?.categoryObject?.name || ""}</TableCell>
                                                    {/* <TableCell id={labelId} align="left" >{`${row?.medicineObject?.dose || ""} ${row?.medicineObject?.unit || ""}`}</TableCell> */}
                                                    <TableCell id={labelId} align="left" >{row?.manufactureDate ? moment(row?.manufactureDate).tz(userdata?.timezoneName || moment.tz.guess()).format('ll') : "N/A"}</TableCell>
                                                    <TableCell id={labelId} align="left" >{row?.expiryDate ? moment(row?.expiryDate).tz(userdata?.timezoneName || moment.tz.guess()).format('ll') : "N/A"}</TableCell>
                                                    <TableCell id={labelId} align="left" > {row?.shelfLife != null
                                                        ? `${row.shelfLife} ${Number(row.shelfLife) === 1 ? "Day" : "Days"}`
                                                        : "N/A"}
                                                    </TableCell>
                                                    <TableCell id={labelId} align="left" style={{ textWrap: "wrap" }}>{row?.quantity != null ? row.quantity : ""}</TableCell>
                                                    <TableCell id={labelId} align="left" style={{ textWrap: "wrap" }}>{`${row?.vendorObject?.name || ""}`}</TableCell>
                                                    <TableCell id={labelId} align="left" style={{ textWrap: "wrap" }}>{`${row?.vendorObject?.vendorStatus === true ? "Active" : "In-active"}` || ""}</TableCell>
                                                    <TableCell id={labelId} align="right" ><MoreVertIcon type="button" data-bs-toggle="dropdown" aria-expanded="false" />
                                                        <ul className="dropdown-menu dropdown-menu-end me-3">
                                                            <li><button className="dropdown-item" onClick={() => { const url = `/setting/inventory/${row?.inventoryId}/details`; navigate(url); }}><i className="fa-solid fa-pen-to-square all_icons_color me-2 fs-6"></i>View Details</button></li>
                                                            <li><button className="dropdown-item" onClick={() => handleOpenModal("addStock", row)} ><i className="fa-solid fa-plus cursor all_icons_color fs-6 me-2" />Add Stock</button></li>
                                                            <li><button className="dropdown-item" onClick={() => handleOpenModal("releaseStock", row)} ><i className="fa-solid fa-minus cursor all_icons_color fs-6 me-2" />Release Stock</button></li>
                                                            <li><button className="dropdown-item" onClick={() => { const url = `/setting/inventory/${row?.inventoryId}/history`; navigate(url); }}><i className="fa-solid fa-clock-rotate-left all_icons_color me-2 fs-6"></i>Stock History</button></li>
                                                            <li><button className="dropdown-item" onClick={() => handleOpenModal("archive", row)}><BiArchiveIn className="all_react_icons_color me-2" />{`${row?.activeStatus === true ? "Archive" : "Unarchive"} Inventory`}</button></li>
                                                        </ul>
                                                    </TableCell>
                                                </TableRow>
                                                </React.Fragment>
                                            }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <nav className=" w-100  " aria-label="pagination">
                            {TotalCount > 10 && <Peginationcomponent count={TotalCount} controller={inventoryController} setController={setInventoryController} />}
                        </nav>
                    </div>
                </div>
            }
            {
                tab === 3 &&
                <div className=" py-2" style={{ height: "100%" }}>
                    <div className='pb-2 d-flex justify-content-between ' style={{ borderBottom: "2px solid #ededed" }}>
                        <ul className="headerlist px-0">
                            <li className='me-2' style={{ width: "210px" }}> <input type="text" placeholder="Search" className="form-control filter_input" name='vendorSearch' value={vendorFilter?.vendorSearch} onChange={handleChangeFilter} /> </li>

                            <li className="me-2" style={{ width: 150 }}>
                                <SelectBox
                                    placeholder="Select"
                                    value={vendorFilter?.vendorArchive}
                                    name="vendorArchive"
                                    keys="value"
                                    label="label"
                                    menuValeu="value"
                                    handleChange={handleChangeFilter}
                                    option={activeStatusOption}
                                />
                            </li>
                            <li className='me-2'><CustomButton disabled={vendorFilter?.vendor_disable_button} startIcon={<IoIosSearch />} variant="contained" onClick={HandleSearchList}>search</CustomButton></li>
                            <li className="me-2" >
                                <IconButton onClick={reset} size="small" aria-label="delete" disabled={vendorFilter?.vendor_disable_button} style={{ color: "#000", cursor: "pointer" }}>
                                    <FiRefreshCcw />
                                </IconButton>
                            </li>
                            <li><CustomButton startIcon={<IoMdAdd />} variant="contained" onClick={() => { const url = `/setting/vendor/add`; navigate(url); }} >add Vendor</CustomButton></li>
                        </ul>
                        <ul className="headerlist px-0 ">
                            <li>
                                <CustomButton variant="contained"
                                    onClick={handleVendorInventory}
                                // style={{ background: "#f5f5f5", color: "black" }}
                                // startIcon={<LuImport />}
                                >Download</CustomButton>
                            </li>
                        </ul>
                    </div>
                    <div className="row" >
                        <div className="col-12 h-100 pt-3">

                            <TableContainer   >
                                {vendorList.length === 0 && <div className="col-sm-12 mt-3 text-center " > <NoRecordFound /> </div>}
                                <Table
                                    id="table_mui"
                                    aria-labelledby="tableTitle"
                                    size={"medium"}
                                    aria-label="enhanced table" >
                                    {
                                        vendorList?.length !== 0 && <EnhancedTableVendor order={orderVendor} orderBy={orderByVendor} onRequestSort={handleRequestSortVendor} rowCount={vendorList?.length} />
                                    }
                                    <TableBody className="table_overflow_scroll" >
                                        {stableSortVendor(vendorList, getComparatorVendor(orderVendor, orderByVendor)).map(
                                            (row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return <React.Fragment key={index}><TableRow id="hover_tr" style={{ cursor: 'pointer' }}>
                                                    <TableCell className="ps-3" component="th" id={labelId} scope="row" padding="none" >
                                                        {vendorController?.rowsPerPage * (vendorController?.page - 1) + index + 1}
                                                    </TableCell>
                                                    <TableCell id={labelId} align="left" >{`${row?.vendorId || ""}`}</TableCell>
                                                    <TableCell id={labelId} align="left" >{`${row?.name || ""}`}</TableCell>
                                                    <TableCell id={labelId} align="left" >{`${row?.category || ""}`}</TableCell>
                                                    <TableCell id={labelId} align="left" > {row?.mobile || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" >{row?.email || ""}</TableCell>
                                                    {/* <TableCell id={labelId} align="left" >{row?.gstNumber || ""}</TableCell>
                                                    <TableCell id={labelId} align="left" style={{ textWrap: "wrap" }}>{row?.panNumber || ""}</TableCell> */}
                                                    <TableCell id={labelId} align="left" >{row?.taxRegistrationNumber || ""}</TableCell>
                                                    <TableCell id={labelId} align="right" ><MoreVertIcon type="button" data-bs-toggle="dropdown" aria-expanded="false" />
                                                        <ul className="dropdown-menu dropdown-menu-end me-3">
                                                            <li><button className="dropdown-item" href="#" onClick={() => { const url = `/setting/vendor/${row?.id}/details`; navigate(url); }} ><i style={{ fontSize: "12px", color: "#888686 ", width: "20px", }} className="fa-solid fa-eye  all_icons_color "></i>View Details</button></li>
                                                            {/* <li><button className="dropdown-item" onClick={() => handleOpenModal("addVendor", row)}><i className="fa-solid fa-pen-to-square all_icons_color me-2 fs-6"></i>Edit Vendor</button></li> */}
                                                            <li><button className="dropdown-item" onClick={() => handleOpenModal("archive", row)}><BiArchiveIn className="all_react_icons_color me-2" />{`${row?.activeStatus === true ? "Archive" : "Unarchive"} Vendor`}</button></li>
                                                        </ul>
                                                    </TableCell>
                                                </TableRow>
                                                </React.Fragment>
                                            }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </div>
                        <nav className=" w-100  " aria-label="pagination">
                            {TotalCount > 10 && <Peginationcomponent count={TotalCount} controller={vendorController} setController={setVendorController} />}
                        </nav>
                    </div>
                </div>
            }
            <AddMedicine data={data} methods={methods} />
            <Modal show={openModal?.archive} onHide={() => handleClosedModal("archive")} centered>
                <Modal.Body>
                    <div className="modal-body text-center">
                        <BiArchiveIn className="all_react_icons_color " />
                        <p className="mb-0">Are you sure?</p>

                        {
                            tab === 1 && (
                                <>
                                    <p>{openModal?.data?.activeStatus === true ? dailogAllMessage.madicine.Archive : dailogAllMessage.madicine.UnArchive}</p>
                                    <CustomButton variant="contained" className="me-3" onClick={() => archiveUnarchive("YES")} > Yes</CustomButton>
                                    <CustomButton variant="outlined" onClick={() => archiveUnarchive("NO")} > No</CustomButton>
                                </>
                            )

                        }
                        {
                            tab === 2 && (
                                <>
                                    <p>{openModal?.data?.activeStatus === true ? dailogAllMessage.inventory.Archive : dailogAllMessage.inventory.UnArchive}</p>
                                    <CustomButton variant="contained" className="me-3" onClick={() => archiveInventory("YES")} > Yes</CustomButton>
                                    <CustomButton variant="outlined" onClick={() => archiveInventory("NO")} > No</CustomButton>
                                </>
                            )

                        }
                        {
                            tab === 3 && (
                                <>
                                    <p>{openModal?.data?.activeStatus === true ? dailogAllMessage.vendor.Archive : dailogAllMessage.vendor.UnArchive}</p>
                                    <CustomButton variant="contained" className="me-3" onClick={() => archiveVendor("YES")} > Yes</CustomButton>
                                    <CustomButton variant="outlined" onClick={() => archiveVendor("NO")} > No</CustomButton>
                                </>
                            )
                        }

                        {/* <p>{openModal?.data?.activeStatus === true ? dailogAllMessage.madicine.Archive : dailogAllMessage.madicine.UnArchive}</p>
                        <CustomButton variant="contained" className="me-3" onClick={() => archiveUnarchive("YES")} > Yes</CustomButton>
                        <CustomButton variant="outlined" onClick={() => archiveUnarchive("NO")} > No</CustomButton> */}
                    </div>
                </Modal.Body>
            </Modal>
            <Modal size={'sm'} show={openModal?.importMedicine} onHide={() => handleClosedModal("importMedicine")} centered>
                <Modal.Body>
                    <div >
                        <div className="d-flex justify-content-between flex-column align-items-center">
                            <div className="bodrerer w-100  mx-0" style={{ border: `${!importFile ? "2px dashed #aaaaaa" : "none"}` }}
                                onDragEnter={handleDragEnter}
                                onDragLeave={handleDragLeave}
                                onDragOver={handleDragOver}
                                onDrop={(e) => handleDrop(e, uploadExcel)}>
                                <label htmlfor="inputTag d-flex">
                                    {
                                        !importFile && <AiOutlineCloudUpload className="fs-4 " />
                                    }
                                    {importFile && <div className='w-100 d-flex justify-content-center align-items-center'>
                                        <img style={{ width: "200px", height: "150px" }} src={require("../../../Assets/Images/xlsx.png")} alt="" />
                                    </div>
                                    }
                                    <input id="inputTag" type="file" name="file"
                                        ref={excelref}
                                        onChange={(event) => uploadExcel(event.target.files[0])}
                                    />
                                    <br />
                                    {
                                        !importFile && <p className="mb-0">Drag file(s) here or <span>click to upload</span></p>
                                    }
                                    <br />
                                </label>
                            </div>
                        </div>
                        <div className='w-100 d-flex justify-content-center'>
                            {
                                importFile && <CustomButton variant="contained" className="theme-btn font-12 fw-5 bgBlue mt-3 px-5" onClick={handleImportMedicine} >Save</CustomButton>
                            }
                        </div>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={openModal?.addStock} onHide={() => handleClosedModal("addStock")} centered>
                <form onSubmit={handleAddAndReleaseStock.handleSubmit}>
                    <Modal.Body>
                        <div className="text-center">
                            <h4 className="modal-title mb-3">Add Stock</h4>
                        </div>
                        <div className="modal-body cus-i">
                            <div className="mb-3">
                                <label htmlFor="stockInput" className="form-label mb-0">
                                    Quantity<span className="Star_Mark">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="stockInput"
                                    name="quantity"
                                    max={9999}
                                    value={handleAddAndReleaseStock.values.quantity}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value <= 9999) {
                                            handleAddAndReleaseStock.setFieldValue("quantity", value);
                                        }
                                    }
                                    }
                                />
                                <Errors formikfun={handleAddAndReleaseStock} name={"quantity"} />
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            <CustomButton type="submit" variant="contained" disabled={loader}>
                                Save
                            </CustomButton>
                        </div>
                    </Modal.Body>
                </form>
            </Modal>

            <Modal show={openModal?.releaseStock} onHide={() => handleClosedModal("releaseStock")} centered>
                <form onSubmit={handleAddAndReleaseStock.handleSubmit}>
                    <Modal.Body>
                        <div className="text-center">
                            <h4 className="modal-title mb-3">Release Stock</h4>
                        </div>
                        <div className="modal-body cus-i">
                            <div className="mb-3">
                                <label htmlFor="stockInput" className="form-label mb-0">
                                    Quantity<span className="Star_Mark">*</span>
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    id="stockInput"
                                    name="quantity"
                                    max={9999}
                                    value={handleAddAndReleaseStock.values.quantity}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value <= 9999) {
                                            handleAddAndReleaseStock.setFieldValue("quantity", value);
                                        }
                                    }
                                    }
                                />
                                <Errors formikfun={handleAddAndReleaseStock} name={"quantity"} />
                            </div>
                        </div>
                        <div className="text-center mt-3">
                            <CustomButton type="submit" variant="contained" disabled={loader}>
                                Save
                            </CustomButton>
                        </div>
                    </Modal.Body>
                </form>
            </Modal>


        </>
    )
}

export default Medicine

